import { observable, computed, reaction, action, runInAction, asMap } from 'mobx'

import { get, getAvailableTags } from 'transport/story'

import UiStore from 'stores/UiStore'
import StoryModel from 'models/StoryModel'

class StoryStore {
  @observable storiesMap = asMap({})

  @computed get stories () {
    const pageIds = this.pages.get(UiStore.pagination.current)

    if (!pageIds) {
      return []
    }

    return pageIds.map(id => this.storiesMap.get(id)).filter(a => a)
  }

  @observable pages = asMap({})

  @observable availableTags = []

  @observable hidePastStories = true

  constructor () {
    this.fetcher = null
  }

  @action async fetchStories () {
    const type = UiStore.route
    const response = await get(UiStore.pagination.current, type, UiStore.storyFilters)
    const toBeMergedList = response[type]
      .map(story => StoryModel.fromJS(story))

    runInAction(() => {
      // update pagination (NOTE fake -- one page for now)
      UiStore.pagination.current = 1
      UiStore.pagination.last = 1

      // merge new storyies into this.storiesMap
      for (let story of toBeMergedList) {
        this.storiesMap.set(story.id, story)
      }

      // remember the ordered story ids for this page
      this.pages.set(UiStore.pagination.current, toBeMergedList.map(({ id }) => id))
    })
  }

  @action async fetchAvailableTags () {
    const type = UiStore.route
    const tags = await getAvailableTags(type)
    for (let tag of tags) {
      this.availableTags.push(tag)
    }
  }

  startFetcher () {
    this.fetchStories()

    this.fetchAvailableTags()

    this.fetcher = reaction(
      // dependencies to watch
      () => [
        this.pages,
        UiStore.pagination.current,
        UiStore.storyFilters.tags
      ],
      // action
      () => {
        if (!this.pages.get(UiStore.pagination.current)) {
          this.fetchStories()
        }
      }
    )
  }

  @action stopFetcher () {
    if (this.fetcher) {
      // dispose reaction
      this.fetcher()

      // clear from memory
      this.clearStories()

      // clear available tags
      this.clearAvailableTags()

      // reset pagination
      UiStore.resetPagination()

      // reset filters
      UiStore.resetStoryFilters()
    }
  }

  @action clearStories () {
    this.storiesMap.clear()
    this.clearPages()
  }

  @action clearPages () {
    this.pages.clear()
  }

  @action clearAvailableTags () {
    this.availableTags.clear()
  }

  @action togglePastStories () {
    this.hidePastStories = !this.hidePastStories
  }
}

const singleton = new StoryStore()
export default singleton



// WEBPACK FOOTER //
// ./resources/assets/js/stores/StoryStore.js